import { render } from "./ServicePayment.vue?vue&type=template&id=6cd9359a&scoped=true"
import script from "./ServicePayment.vue?vue&type=script&lang=js"
export * from "./ServicePayment.vue?vue&type=script&lang=js"

import "./ServicePayment.vue?vue&type=style&index=0&id=6cd9359a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd9359a"]])

export default __exports__